import React, {useEffect, useState} from "react";
import {getFetcherAnalysis} from "../../utils/fetcher_gameAnlysis";
import {GET_STRENGTH_ANALYSIS_DATA_REPORT_API} from "../../constants/api_constants";
import {getImage} from "../../constants/constants";
import WinningBarGraph from "./WinningBarGraph";
import BarGraph from "./BarGraph";
import neverLandUtils from "../../utils/NeverLandUtils";
import {basketballMaxValue} from "./StrengthAnalysisComponent";


const StrengthAnalysisComponentFromReport = ({dataId, analysisType}) => {
  // 상단 최근 결과
  const [homeTeamRecordText, setHomeTeamRecordText] = useState("");
  const [awayTeamRecordText, setAwayTeamRecordText] = useState("");
  // 하단 막대 그래프
  const [matchData, setMatchData] = useState([]); // 그래프 데이터

  const [buttunSelectData, setButtunSelectData] = useState(1); // 1: 전체, 2.홈/원정, 3.원정경기 FIXME: 버튼 데이터 차후 수정
  const [isLoading, setIsLoading] = useState(true);
  const [isNullData, setIsNullData] = useState(false);

  useEffect(() => {
    getStrengthAnalysisData();
  }, []);

  const getStrengthAnalysisData = () => {
    // 전력 분석
    getFetcherAnalysis().get(GET_STRENGTH_ANALYSIS_DATA_REPORT_API + `?dataId=${dataId}&recodeType=${buttunSelectData}&analysisType=${analysisType}`)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          if (responseIsSuccess) {
            if (data.length === 0) {
              setIsNullData(true);
              setIsLoading(false);
              return;
            }
            setHomeTeamRecordText(data[0].records.homeTeamRecordText);
            setAwayTeamRecordText(data[0].records.awayTeamRecordText);
            setMatchData(data[0].details);

            setIsLoading(false);
          } else {
            console.log("데이터 불러오기 실패 -> ", responseResultDescription);
            setIsNullData(true);
            setIsLoading(false);
          }
        }).catch(err => console.log(err));
  }

  const getBarGraphConfigByName = (name) => {
    // 배열에 값이 지정되어있는 항목은 maxValue 반환하고 % 항목은 isPercent=true 반환
    const trimmedName = name.trim();
    const isInclude = basketballMaxValue.find(item => item.key === trimmedName);
    const isPercent = trimmedName.includes('%');

    return {
      maxValue: isInclude ? isInclude.maxValue : -1,
      isPercentValue: isPercent
    };
  };

  const setResultColor = (text) => {
    // 승무패에 따라 텍스트 색상 지정
    if (!text) return null;

    return text.split(/(\[승\]|\[패\]|\[무\])/).map((word, index) => {
      let colorClass = "";
      if (word === "[승]") {
        colorClass = "text-red-600"; // 빨간색
      } else if (word === "[패]") {
        colorClass = "text-blue-600"; // 파란색
      } else if (word === "[무]") {
        colorClass = "text-black"; // 검정색
      }

      return (
          <span key={index} className={colorClass}>
            {word}
          </span>
      );
    });
  };

  if (isLoading) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('loadingImage')} alt="loadingImage" className="h-32 w-auto"/>
          <span className="font-bold text-sky-700"> 데이터 불러오는중... </span>
        </div>
    )
  }
  if (isNullData) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('notFound')} alt="notFoundImage" className="h-40 w-auto"/>
          <span className="font-bold text-indigo-800 pt-3 text-lg pointer-events-auto"> 데이터가 없습니다. </span>
        </div>
    )
  }

  const homeAwayWinRate = matchData?.find(detail => detail.title === "홈원정승률")?.item[0];

  let homeTeamRecords = homeTeamRecordText.split('|');
  let awayTeamRecords = awayTeamRecordText.split('|')


  function getRecordText(teamRecords) {
    if (teamRecords.length === 2) {
      return teamRecords[1];
    }

    let text = "";
    let temp;
    for (let index = 1; index < teamRecords.length; index++) {
      temp = teamRecords[index].trim();
      if (temp.length == 0)
        continue;
      if (!temp.startsWith('[') && !temp.endsWith(']')) {
        temp = '[' + temp + ']';
      }
      text += temp;
    }

    return text;
  }

  return (
      <div className="pl-2 h-full overflow-y-scroll">
        <span className="text-xl font-bold">전력분석 통계</span>
        {analysisType === "report" && <span className="text-md font-bold"> [시즌 전체 평균]</span>}

        {/*홈팀 전적 통계 */}
        <div className="flex flex-row items-center justify-start my-3 w-full">
          <span className="text-white bg-red-600 mr-2 px-2 py-1 rounded-full w-1/4 max-w-1/4 text-center">
            {neverLandUtils.trimTeamName(homeTeamRecords[0])}
          </span>
          <div className="border border-black py-1 w-3/4 text-center rounded-full shadow-md">
            {setResultColor(getRecordText(homeTeamRecords))}
          </div>
        </div>

        {/*원정팀 전적 통계 */}
        <div className="flex flex-row items-center justify-start mb-3 w-full">
          <span className="text-white bg-blue-600 mr-2 px-2 py-1 rounded-full w-1/4 max-w-1/4 text-center">
            {neverLandUtils.trimTeamName(awayTeamRecords[0])}
          </span>
          <div className="border border-black py-1 w-3/4 text-center rounded-full shadow-md">
            {setResultColor(getRecordText(awayTeamRecords))}
          </div>
        </div>

        <div className="my-5">
          {/* <-- 홈 원정 승률 --> */}
          {homeAwayWinRate && <WinningBarGraph data={homeAwayWinRate}/>}

          {/* <-- 모든 상세 데이터 동적 출력 --> */}
          {matchData
              .filter(data => data.title && data.title !== "홈원정승률" && data.title !== "none") // "홈원정승률", "none" 제외
              .map((data, index) => (
                  <div key={index} className="flex flex-col border border-black mt-3">
                    <h2 className="flex justify-center items-center bg-gray-900 text-white mb-2">{data.title}</h2>
                    {data.item.map((item, index) => {
                      const {maxValue, isPercentValue} = getBarGraphConfigByName(item.name);

                      return (
                          <BarGraph item={item}
                                    key={index}
                                    isPercentValue={isPercentValue}
                                    maxValue={maxValue}
                          />
                      )
                    })}
                  </div>
              ))}
        </div>
      </div>
  )
}
export default StrengthAnalysisComponentFromReport;




